export default "/images/contest-slide2.jpeg?ebd73b80e2550c5b757d91c4fafc401e";